import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services'
import {
  GetCompletedSessionsRequest,
  GetCompletedSessionsResponse,
  GetSessionsRequest,
  GetSessionsResponse,
  CompletedSessions
} from './type'
import apiEndpoints from '../../const/apiEndpoints'

export const getCompletedSessions = createAsyncThunk(
  'live/completedsessions',
  async (
    data: GetCompletedSessionsRequest
  ): Promise<GetCompletedSessionsResponse> => {
    const response = await api.post(
      apiEndpoints.getCompletedSessionsSubject,
      data
    )
    const completedSessions = response.data.map(
      ({ id, courseName, parentName }: CompletedSessions) => ({
        id,
        courseName,
        parentName
      })
    )
    return completedSessions
  }
)

export const getSessions = createAsyncThunk(
  'live/getSessions',
  async (data: GetSessionsRequest): Promise<GetSessionsResponse> => {
    const response = await api.post(apiEndpoints.getSessions, data)
    const sessions = response.data.data.map((session: any) => ({
      id: session.id,
      sessionName: session.sessionName,
      startTime: session.startTime,
      endTime: session.endTime,
      subjectName: session.subject?.courseName,
      sessionDate: session.sessionDate,
      sessionRecordingUrl: session.sessionRecordingUrl,
      url: session.url,
      facultyName:
        `${session.userDetail.firstName} ${session.userDetail.lastName}`.trim()
    }))
    return { sessions, sessionTense: data.sessionTense }
  }
)
